





















import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator'
import Validatable from '@/mixins/Validatable'
import { SelectGridOption } from '@/store/types'

@Component
export default class SelectGrid extends Mixins(Vue, Validatable) {
	@Prop({ type: [String, Number] }) readonly value!: string | number
	@Prop({ type: Array, default: Array, required: true }) options!: SelectGridOption[]

	get className() {
		return {
			error: Boolean(this.errorMsg),
		}
	}

	@Watch('options', { immediate: true }) // immediate: true - запускает watch даже на самом старте приложения
	onOptionsChanged() {
		const select = this.options.length === 1
			? this.options[0] // если опция только одна, то она сразу выбрана
			: this.options.find(item => item.value === this.value) // восстаналивает прошлый выбор когда в новом списке есть такая же опция
		this.updateValue(select && !select.disabled ? select.value : null)
	}

	async updateValue(value: string | number) {
		this.$emit('input', value)
	}

	onClick(item: SelectGridOption) {
		if (item.disabled) return
		this.updateValue(item.value)
	}
}
